import actionsDirectDebet from "./actions";

export default {
  namespaced: false,
  actions: actionsDirectDebet,
};
